<template>
    <div class="container">
        <div class="through" @animationend="through" v-if="type === 1"></div>
        <FrameAnimation
            pic="/img/xj/body.png"
            frames="3"
            :time="750"
            :run="(type > 0 && !paused) || type > 2 && type !== 3"
            @animationend="bodyMove"
            :class="['body scene1', {bodyRun: type === 1, fade: type === 2, r_y: type === 3, bodyRun2: type === 4}]"
            v-if="type > 0 && type < 5"/>
        <FrameAnimation
            pic="/img/xj/body.png"
            frames="3"
            :time="1000"
            :run="!pausedScene2"
            @animationend="bodyMoveScene2"
            :class="['body scene2', {paused: pausedScene2,fade: type > 5}]"
            v-if="type > 4"/>
        <FrameAnimation
            pic="/img/xj/lu_run.png"
            frames="8"
            :time="1200"
            :run="!pausedScene2"
            class="fast_deer"
            v-show="type > 4"/>
        <FrameAnimation
            pic="/img/xj/lu.png"
            frames="2"
            :time="600"
            :run="type === 1 && !deerMoveOver"
            @animationend="deerMove"
            :class="['deer', {run: type === 1, fade: deerMoveOver}]"/>
        <div :class="['stone', {z: type > 2}]"></div>
    </div>
</template>

<script>
import FrameAnimation from '@page/xuejinghanlintu/components/FrameAnimation';

export default {
    components: {
        FrameAnimation
    },
    props: ['type'],
    data() {
        return {
            bodyRun: false,
            paused: false,
            pausedScene2: false,
            deerMoveOver: false
        };
    },
    watch: {
        type(val) {
            if (!val) {
                this.bodyRun = false;
                this.paused = false;
                this.deerMoveOver = false;
            }
        }
    },
    methods: {
        through() {
            this.bodyRun = true;
        },
        bodyMove() {
            this.paused = true;
        },
        bodyMoveScene2() {
            this.pausedScene2 = true;
        },
        deerMove() {
            this.deerMoveOver = true;
        }
    }
};
</script>

<style lang="stylus" scoped>
@keyframes bodyMove_scene2
    0%,20%
        opacity 0
        transform translate3d(0, 0, 1px)
    30%
        opacity 1
    100%
        transform translate3d(14vw, 0, 1px)
        opacity 1
@keyframes bodyMove
    0%,30%
        opacity 0
        transform translate3d(0, 0, 1px)
    40%
        opacity 1
        transform translate3d(0, 0, 1px)
    100%
        transform translate3d(8vw, -1vh, 1px)
        opacity 1
@keyframes bodyMove2
    0%
        opacity 1
        transform translate3d(8vw, -1vh, 1px) rotateY(180deg)
    99.9%
        opacity 1
        transform translate3d(0, -1vh, 1px) rotateY(180deg)
    100%
        opacity 1
        display none
        transform translate3d(0, -1vh, 1px) rotateY(180deg)
@keyframes fast_deer_move
    0%
        transform rotateY(180deg) translate3d(0,0,1px)
        opacity 0
    10%
        opacity 1
    100%
        opacity 1
        transform rotateY(180deg) translate3d(-60vw,0,1px)
@keyframes deerMove
    0%
        transform translate3d(0, 0, 1px)
    100%
        transform translate3d(-12vw, -1.5vh, 1px)
@keyframes through
    0%, 40%
        opacity .4
    20%, 60%
        opacity .6
    90%,100%
        opacity 1
@keyframes fade
    0%
        opacity 1
    100%
        opacity 0
@keyframes show
    0%
        opacity 0
        transform translate3d(8vw, -1vh, 1px) rotateY(180deg)
    100%
        transform translate3d(8vw, -1vh, 1px) rotateY(180deg)
        opacity 1
.container
    size 100%
    position absolute
    left 0
    right 0
    .through
        position absolute
        bottom 9.5%
        left 14%
        size 1.04rem 2.06rem
        background url('/img/xj/through.png') 0 0/100% 100% no-repeat
        animation through 2.5s linear, fade 1s linear forwards 2.5s;
        z-index 2
    .body
        position absolute
        &.scene1
            size .65rem .74rem
            bottom 14%
            left 16%
            z-index 2
            &.bodyRun
                animation bodyMove 6s linear forwards
            &.paused
                animation-play-state paused
            &.fade
                animation bodyMove 6s linear forwards,
                    fade 1s linear forwards 2s
                animation-play-state paused, running
            &.r_y
                transform rotateY(180deg)
                animation bodyMove 6s linear forwards,
                    fade 1s linear forwards 2s,
                    show 1s linear forwards .1s
                animation-play-state paused, paused, running
            &.bodyRun2
                animation bodyMove 6s linear forwards,
                    fade 1s linear forwards 2s,
                    show 1s linear forwards .1s,
                    bodyMove2 6s linear forwards .1s
                animation-play-state paused, paused, paused, running
                z-index 0
        &.scene2
            size (.65*0.7)rem (.74*0.7)rem
            right 27%
            bottom 24%
            opacity 0
            animation bodyMove_scene2 10s linear forwards 7s
            &.paused
                animation-play-state paused
            &.fade
                animation bodyMove_scene2 10s linear forwards 7s,
                    fade 1s linear forwards .5s
                animation-play-state paused, running
    .fast_deer
        position absolute
        size 1rem .67rem
        right 27%
        bottom 24%
        transform rotateY(180deg)
        opacity 0
        animation fast_deer_move 3s linear forwards 7.5s
    .deer
        position absolute
        size 1.8rem 1.2rem
        bottom 10%
        left 35%
        &.run
            animation deerMove 8s linear forwards
        &.fade
            transition opacity 1s
            opacity 0
    .stone
        position absolute
        top 0
        left 0
        size 100%
        background url('/img/xj/stone.png') 0 0/100% 100% no-repeat
        transform translate3d(0, 0, 1px)
</style>
